<template>
  <div class="page">
    <div class="header">
      <img class="logo" src="https://www.enchy.ru/upload/iblock/ef2/ef25a2ef179a75a4328d3a64c40328e7.png"/>
      <p class="title"> Скажите СПАСИБО 💙 коллеге! </p>
    </div>
    <div class="form">
      <NotificationComponent v-if="loginError.length > 0" :content="loginError" />
      <div class="label">Номер телефона</div>
      <input autocomplete="false" class="input" type="text" v-model="phone" @input="inputPhone"
             placeholder="Номер телефона"/>
      <button class="btn" @click="sendCode" v-if="code === null && phone.length === 18"> Отправить код</button>
      <div style="font-size: 12px; margin-top: 8px; color: #cdcdcd" v-if="code !== null">Код</div>
      <input autocomplete="false" class="input" v-if="code !== null" type="text" v-model="code" @input="inputCode()"
             placeholder="Код"/>
      <button class="btn" @click="signIn" v-if="code !== null"> Вход</button>
    </div>
  </div>
</template>

<script>
import NotificationComponent from './components/NotificationComponent'

export default {
  name: 'LoginPage',
  components: {
    NotificationComponent
  },
  data: function () {
    return {
      loginError: '',
      phone: sessionStorage.getItem('auth_phone') || '7',
      code: sessionStorage.getItem('auth_code_sent') ? '' : null
    }
  },
  created() {
    this.loadProfile()
    this.inputPhone()
  },
  methods: {
    inputCode() {
      this.loginError = ''
      if (this.code.length === 4)
        this.signIn()
    },
    loadProfile() {
      if (localStorage.getItem('phone') !== null)
        this.$router.push('/profile')
    },
    signIn() {
      const phone = this.phone.replace(/\D/g, '')
      this.$store.dispatch('signIn', { code: this.code, phone: phone })
          .then((res) => {
            if (res !== true) {
              localStorage.setItem('token', res)
              localStorage.setItem('phone', phone)
              sessionStorage.removeItem('auth_code_sent')
              sessionStorage.removeItem('auth_phone')
              this.phone = '7'
              this.inputPhone()
              this.code = null
              this.loadProfile()
            } else {
              this.loginError = 'Неверный код'
              sessionStorage.removeItem('auth_code_sent')
            }
          })
          .catch(err => {
            console.log(err)
            this.code = ''
            sessionStorage.removeItem('auth_code_sent')
            alert('Код не подходит')
          })
    },
    sendCode() {
      const phone = this.phone.replace(/\D/g, '')
      this.$store.dispatch('sendCode', phone)
          .then((res) => {
            if (res.length > 0) {
              this.loginError = res
            } else {
              this.code = ''
              sessionStorage.setItem('auth_code_sent', 'true')
              sessionStorage.setItem('auth_phone', this.phone)
              alert(`На номер ${this.phone} отправлен код`)
            }
          })
          .catch(err => console.log(err))
    },
    inputPhone() {
      this.loginError = ''
      const prefixNumber = (str) => {
        if (str === "7") {
          return "7 (";
        }
        if (str === "8") {
          return "8 (";
        }
        if (str === "9") {
          return "7 (9";
        }
        return "7 (";
      };

      const value = this.phone.replace(/\D+/g, "");
      const numberLength = 11;

      let result;
      if (this.phone.includes("+8") || this.phone[0] === "8") {
        result = "";
      } else {
        result = "+";
      }

      for (let i = 0; i < value.length && i < numberLength; i++) {
        switch (i) {
          case 0:
            result += prefixNumber(value[i]);
            continue;
          case 4:
            result += ") ";
            break;
          case 7:
            result += "-";
            break;
          case 9:
            result += "-";
            break;
          default:
            break;
        }
        result += value[i];
      }

      this.phone = result;
    }
  }
}
</script>

<style>
.page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around
}

.header {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo {
  width: 10em;
}

.title {
  padding: 32px;
  font-size: 16px;
  letter-spacing: 0.33px;
  color: white;
}

.form {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 320px;
  width: 320px;
}

.label {
  font-size: 12px;
  color: #cdcdcd;
}

.input {
  outline: none;
  background: #eeeeee;
  margin: 12px 0;
  border-radius: 8px;
  padding: 8px 12px;
  border: none;
  width: calc(100% - 56px);
  color: #434444;
}

.input::placeholder {
  color: #999;
}

:active, :hover, :focus {
  outline: 0;
  outline-offset: 0;
}

::placeholder {
  color: #ccc;
}

.btn {
  background: #ffffff35;
  color: #fff;
  padding: 6px 16px;
  border: none;
  border-radius: 8px;
}
</style>